module.exports = __webpack_public_path__ + "static/media/doc.bf47b291.svg";